import React from 'react';

/**
 * Reusable component for visualization type controls
 * 
 * @param {string} visualizationType - Current visualization type (piechart, barchart, linechart)
 * @param {Function} setVisualizationType - Function to set visualization type
 */
const VisualizationControls = ({ visualizationType, setVisualizationType }) => {
  return (
    <div className="flex space-x-2 mb-4">
      <button
        onClick={() => setVisualizationType('piechart')}
        className={`px-4 py-2 rounded-md text-sm font-medium ${
          visualizationType === 'piechart' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        Pie Chart
      </button>
      <button
        onClick={() => setVisualizationType('barchart')}
        className={`px-4 py-2 rounded-md text-sm font-medium ${
          visualizationType === 'barchart' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        Bar Chart
      </button>
      <button
        onClick={() => setVisualizationType('linechart')}
        className={`px-4 py-2 rounded-md text-sm font-medium ${
          visualizationType === 'linechart' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        Line Chart
      </button>
    </div>
  );
};

export default VisualizationControls;